import React from 'react';

import { DOTS_FULL_DATE_FORMAT } from 'core/constants';

import { formatFloating } from 'utils/formatters/timezone';

import { SeparatorProps } from './types';
import { Header, SeparatorContainer, Line } from './styles';

// The key is a tz-free YYYY-MM-DD; new Date() read it as UTC midnight, a day early west of UTC
const dayHeading = (day: string): string => formatFloating(day, 'date', DOTS_FULL_DATE_FORMAT);

const Separator = ({ activity, children }: SeparatorProps): React.ReactElement => (
  <SeparatorContainer>
    <Line />
    {activity ? (
      <Header id={`feed-separator-${dayHeading(activity.created)}`}>{dayHeading(activity.created)}</Header>
    ) : (
      <Header>{children}</Header>
    )}
    <Line />
  </SeparatorContainer>
);

export default Separator;
